export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface LogMeta {
  [key: string]: any;
}

export interface LogEntry {
  timestamp: string;
  level: LogLevel;
  message: string;
  meta?: LogMeta;
  correlationId?: string;
  module: string;
  sessionId: string;
}

export interface LogTransport {
  log(entry: LogEntry): Promise<void>;
  flush?(): Promise<void>;
}

export interface LoggerConfig {
  level: LogLevel;
  transports: LogTransport[];
  sampling: number;
  module: string;
}

export enum LogMode {
  DEBUG = 'debug',
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export interface SamplingConfig {
  debug: number;
  info: number;
  warn: number;
  error: number;
}
